import React from 'react';

const Home = () => <div className="row">
    <div className="col-md-4 col-xs-12"></div>
    <div className="col-md-4 col-xs-12 text-center">
        <img src="/images/vinod.jpg" alt="Vinod Kumar Kayartaya" className="img img-thumbnail"/>
        <h3>Movie Browser App</h3>
        <p>Powered by Reactjs 16.13.0</p>
    </div>
    <div className="col-md-4 col-xs-12"></div>
</div>;

export default Home;